import * as d3 from "d3";
import { calcBoundedLimit, lettersRe } from "./utils";

/**
 * @this {import('alpinejs').AlpineComponent}
 */
export default function horizontalBarChart(options) {
  let boundedHeight;
  let boundedWidth;
  let x, y;
  let data;
  let show = false;
  let animate = false;

  const scales = (
    xIndex,
    yIndex,
    offset,
    offsetRight = 0,
    paddingInner = 0,
    padddingOuter = 0
  ) => {
    x = d3.scaleLinear().range([0, boundedWidth - offset - offsetRight]);
    y = d3
      .scaleBand()
      .domain((data || []).map((d) => d[yIndex]))
      .range([0, boundedHeight])
      .paddingInner(paddingInner)
      .paddingOuter(padddingOuter);

    x.domain([0, d3.max(data || [], (d) => +d[xIndex]) || 0]);
  };

  function initializeSvg(width, height, margin) {
    const { boundedHeight: bh, boundedWidth: bw } = calcBoundedLimit(
      width,
      height,
      margin
    );
    boundedHeight = bh;
    boundedWidth = bw;
  }

  return {
    ...options,
    async init() {
      data = await d3.csv(options.url);
      this.$watch("width", () => {
        this.show = false;
        // on re-calcule tout
        initializeSvg(this.width, this.height, this.margin);
        scales(
          this.xIndex,
          this.yIndex,
          this.offset,
          this.offsetRight,
          this.paddingInner,
          this.paddingOuter
        );
        this.$nextTick(() => (this.show = true));
      });
    },
    translateChart() {
      return `translate(${this.margin.left},${this.margin.top})`;
    },
    formatNumber(/** @type {number} */ n) {
      return n >= 1000000
        ? n.toLocaleString("fr", {
            notation: "compact",
            compactDisplay: this.compactDisplay,
          })
        : n.toLocaleString("fr");
    },
    splitAt(s, at) {
      return [
        s.split(" ").slice(0, at).join(" "),
        s.split(" ").slice(at).join(" "),
      ].filter(Boolean);
    },
    splitWords(s, n) {
      const re = new RegExp(
        `[${lettersRe}0-9'\\-]+(?:\\s+[${lettersRe}0-9'\\-]+){0,${n}}`,
        "g"
      );
      return s.match(re);
    },
    get data() {
      return data;
    },
    get x() {
      return x;
    },
    get y() {
      return y;
    },
    get show() {
      return show;
    },
    set show(s) {
      show = s;
    },
    get animate() {
      return animate;
    },
    set animate(a) {
      animate = a;
    },
  };
}
